<mat-form-field class="example-full-width" style="width: 100%">
    <mat-icon style="margin-top: 10px;">manage_accounts</mat-icon>
    <input style="font-size: 22px; margin-left: 28px; color: black;  height: 49px; margin-top: -34px;" matInput disabled
        value="Users">
</mat-form-field>